// Centralized GraphQL documents for interview flows (JS-only)
import { gql } from "@apollo/client";

export const START_INTERVIEW_GQL = gql`
  mutation StartInterview($applicationId: String!) {
    startInterview(applicationId: $applicationId) {
      _id
      transcripts
      duration
      currentSectionDuration
      recording {
        _id
        state
      }
    }
  }
`;

export const START_AI_INTERVIEW_PART_GQL = gql`
  mutation StartAiInterviewPart($applicationId: String!, $sectionId: String) {
    startAiInterviewPart(applicationId: $applicationId, sectionId: $sectionId) {
      _id
      name
      duration
      token
      isLast
      order
    }
  }
`;

export const UPDATE_INTERVIEW_GQL = gql`
  mutation UpdateInterview($recordingId: String!, $transcript: String, $duration: Int, $currentSectionId: String!, $currentSectionDuration: Int) {
    updateInterview(recordingId: $recordingId, transcript: $transcript, duration: $duration, currentSectionId: $currentSectionId, currentSectionDuration: $currentSectionDuration) {
      _id
    }
  }
`;

export const STOP_INTERVIEW_GQL = gql`
  mutation StopInterview($recordingId: String!, $transcript: String, $feedback: String, $score: Int, $currentSectionId: String) {
    stopInterview(recordingId: $recordingId, transcript: $transcript, feedback: $feedback, score: $score, currentSectionId: $currentSectionId) {
      _id
      applications {
        _id
        interview {
          _id
          isFinished
          recording {
            _id
            state
          }
        }
      }
    }
  }
`;
